module.exports = __webpack_public_path__ + "img/college1.5c279788.png";